import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { getActiveChains,submitLiquidityApplicationForm } from "../../Action/action";
import { checkContractOnChain } from "../../Web3/web3FunctionCall";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useDisconnect, useAccount } from "wagmi";
import Web3WalletProvider from '../../ConnectWallet/walletProvider'
import {GetTokenSymbol,NewPool,ApproveToken,ApproveUsdtToken}  from '../../Web3/Liquidity/swapConnector'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineDateRange } from "react-icons/md";
import { showLoader,hideLoader } from "../loader";
import config from "../../config";


export default function MultichainSwapForm() {
  const [form, setForm] = useState({
    tokenName: "",
    tokenAddress: "",
    tokenSymbol:"",
    chainNetwork: "",
    description: "",
    startDateAndTime:"",
    logo: null,
    kyc: "",
    audit: "",
    website: "",
    liquidityValue: "",
    usdtAmount:"",
    whitepaper: "",
    socialAccounts: [{ name: "", link: "" }],
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [chainOptions, setChainOptions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [update, setUpdate] = useState(false);
  const [getRpc, setRpc] = useState();
  const [fields, setFields] = useState([{ name: "" }]);
  const [chainId, setChainId] = useState('')
  const [symbol,setSymbol] = useState("")
  const [swapAddr, setSwapAddr] = useState('')
  const [usdtAddr, setUsdtAddr] = useState('')
  const [presaleLoading, setPresaleLoading] = useState(false)
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  let _useWeb3WalletProvider = Web3WalletProvider()
  
  //const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const navigate = useNavigate();
  const {address, isConnected} = useAccount()

  useEffect(() => {
    getChains();
  }, []);

  const getChains = async () => {
    try {
      const response = await getActiveChains();
      if (response.success) {
        setChainOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    if (name == "chainNetwork") {
      for (let i = 0; i < chainOptions.length; i++) {
        if (chainOptions[i].id == value) {
          setRpc(chainOptions[i].chainRPCUrl);
          setChainId(chainOptions[i].chainNetworkId)
          setSwapAddr(chainOptions[i].pairContractAddress)
          setUsdtAddr(chainOptions[i].usdtContract)
        }
      }
    }
    if (name === "tokenAddress" ) {
          if(!form.chainNetwork) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            chainNetwork: "Please select a chain network before entering the token address."
          }))
          return
        }
          const totalTokenSupply = async () => {
            let request = {
              walletProvider:  _useWeb3WalletProvider,
              tokenAddress:value,
              networkId:chainId
            }
            let res = await GetTokenSymbol(request)
            console.log('SSSSS',res)
            let symb = res.symbol
            setSymbol(symb)
    
          } 
          await totalTokenSupply()
        }

    setForm({
      ...form,
      [name]: value,
    });
  };

const now = new Date();
const minSelectableTime = new Date();
minSelectableTime.setMinutes(minSelectableTime.getMinutes() + 15);

  const handleFileChange = (e) => {
    setForm({
      ...form,
      logo: e.target.files[0],
    });
    setImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const handleCheckboxChange = (e) => {
    setForm({
      ...form,
      agree: e.target.checked,
    });
  };

const validateForm = async () => {
  const newErrors = {};
  const urlPattern =
    /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;

  const isInvalidNumber = (value) => isNaN(value) || value === '' || value <= 0;
  const requiredFields = [
    "tokenName",
    "tokenAddress",
    "description",
    "website",
    "logo",
    "liquidityValue",
    "whitepaper",
    "usdtAmount"
  ];


  requiredFields.forEach((field) => {
    const value = form[field];
    if (!value || (["liquidityValue", "usdtAmount"].includes(field) && isInvalidNumber(value))) {
      newErrors[field] = `${field} is required and must be a valid positive number`;
    }
  });

  if (!form.website) {
    newErrors.website = "Website is required";}
      
    const price = parseFloat(form.usdtAmount) / parseFloat(form.liquidityValue)
      console.log('PXX',price)
      if (parseFloat(price.toFixed(5)) <= 0) {
        newErrors.liquidityValue = "Invalid Liquidity.Price cannot be 0"
        newErrors.usdtAmount = "Invalid Liquidity.Price cannot be 0"
    }

    const socialLinks = ["website", "telegram", "youtube", "linkedin"];
    socialLinks.forEach((field) => {
      if (form[field] && !urlPattern.test(form[field])) {
        newErrors[field] = `Invalid URL format for ${field}`;
      }
    });

  if (!form.agree) {
    newErrors.agree = "You must agree to the terms";
  }
  
  let result = await checkContractOnChain(getRpc, form.tokenAddress);
  if (!result.status) {
    newErrors.tokenAddress = `${result.msg}`;
  }

  console.log(newErrors);
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};
   
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if(!isConnected) {
  //     toast.error("Please connect your wallet.");
  //     setconnectWalletNow(true)
  //     return
  //   }
  //   // if(address.toUpperCase() != loginDetails.walletAddress.toUpperCase()) {
  //   //   toast.error("Please connect with registered wallet address")
  //   //   return
  //   // }

  //    if (await validateForm()) {
  //      console.log("Liquidity Form submitted", form);
     
  //      form.owner_address = address
  //      form.socialAccount = JSON.stringify(form.socialAccounts);
  //      form.tokenSymbol = symbol
  //      //console.log("Liquidity Form submitted", form);
  //       setPresaleLoading(true)
  //       showLoader()
  //       try {
  
  //         let request = {
  //           walletProvider:  _useWeb3WalletProvider,
  //           tokenOwner: address,
  //           tokenAddress:form.tokenAddress,
  //           tokenAmount:form.liquidityValue,
  //           usdtAmount:form.usdtAmount,
  //           pairContractAddress:swapAddr,
  //           usdtAddress: usdtAddr,
  //           startDateAndTime: form.startDateAndTime,
  //           networkId:chainId
  //         }
  //         console.log('RRR',request)
  //         let tokenApproval = await ApproveToken(request)
  //         console.log('tok approval',tokenApproval)
  //         if (tokenApproval.status) {
  //           let usdtApproval = await ApproveUsdtToken(request)
  //           console.log('liquifdity FORMRES',usdtApproval)
  //             if (usdtApproval.status) {
  //           let res = await NewPool(request)
  //           console.log('new liquid',res)
  //           if (res.status) {
  //             toast.success (res.message)
  //             let result = await submitLiquidityApplicationForm(form)
  //             navigate(`${config.baseUrl}launchpad`, {replace: true})
  //             window.scrollTo(0,0)
  //           } else {
  //           toast.error(res.message)
  //             setPresaleLoading(false)
  //           }
  //         } else {
  //           toast.error(usdtApproval.message)
  //           console.log('USDT approval error',usdtApproval.message)
  //         } 
  //       }
  //         else {
  //           toast.error(tokenApproval.message)
  //            console.log('Token approval error',tokenApproval.message)
  //         }
  //     } catch (error) {
  //       console.log('Error Pool',error)
  //       toast.error('Presale Pool',error)
  //     } finally {
  //       hideLoader()
  //     }
  //  } else {
  //      toast.error("Please check the validations required.");
  //    }
  // };



  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isConnected) {
    toast.error("Please connect your wallet.");
    setconnectWalletNow(true);
    return;
  }

  if (!(await validateForm())) {
    toast.error("Please check the validations required.");
    return;
  }

  setPresaleLoading(true);
  showLoader();

  try {
    const request = {
      walletProvider: _useWeb3WalletProvider,
      tokenOwner: address,
      tokenAddress: form.tokenAddress,
      tokenAmount: form.liquidityValue,
      usdtAmount: form.usdtAmount,
      pairContractAddress: swapAddr,
      usdtAddress: usdtAddr,
      startDateAndTime: form.startDateAndTime,
      networkId: chainId
    };

    form.owner_address = address;
    form.socialAccount = JSON.stringify(form.socialAccounts);
    form.tokenSymbol = symbol;

    const tokenApproval = await ApproveToken(request);
    if (!tokenApproval.status) {
      toast.error(tokenApproval.message || "Token approval failed");
      return;
    }
    if (!tokenApproval.alreadyApproved) {
      toast.success("Token approved successfully");
    }

    const usdtApproval = await ApproveUsdtToken(request);
    if (!usdtApproval.status) {
      toast.error(usdtApproval.message || "USDT approval failed");
      return;
    }
    if (!usdtApproval.alreadyApproved) {
      toast.success("USDT approved successfully");
    }

    const res = await NewPool(request);
    if (res.status) {
      toast.success(res.message);
      await submitLiquidityApplicationForm(form);
      navigate(`${config.baseUrl}launchpad`, { replace: true });
      window.scrollTo(0, 0);
    } else {
      toast.error(res.message);
      setPresaleLoading(false);
    }

  } catch (error) {
    console.error("Error Pool:", error);
    toast.error("Presale Pool Error");
  } finally {
    hideLoader();
  }
};

  const handleChange = (index, event) => {
    const newFields = [...fields];
    newFields[index].name = event.target.value;
    setFields(newFields);
  };

  const handleAddField = () => {
    setFields([...fields, { name: "" }]);
  };

  const handleSocialAccountChange = (index, e) => {
    const { name, value } = e.target;
    const socialAccounts = [...form.socialAccounts];
    socialAccounts[index][name] = value;
    setForm({
      ...form,
      socialAccounts,
    });
  };

  const addSocialAccount = () => {
    setForm({
      ...form,
      socialAccounts: [...form.socialAccounts, { name: "", link: "" }],
    });
  };


  return (
    <>
      <Toaster />
      <Header />
      <section className="process_form">
        <Container>
          <Form >
            <div className="from_box my-5">
              <h2>The Launch process:</h2>
              <p>
                Must be confirmed with the Owner wallet (the tokens will be
                transferred to the INFI CDEX Launchpool)
              </p>

              <p
                style={{
                  textAlign:"right",
                  fontSize: "12px",
                  fontStyle: "italic",
                  marginTop:"-10px"
                }}
              >Fields marked with * are compulsory</p>

              <Row>
                <Col lg={6} className="mt-4">
                  <Form.Label>Token Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenName"
                    value={form.tokenName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenName}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>Chain Network *</Form.Label>
                  <Form.Control
                    as="select"
                    name="chainNetwork"
                    value={form.chainNetwork}
                    onChange={handleInputChange}
                    isInvalid={!!errors.chainNetwork}
                  >
                    <option value="">Select Network</option>
                    {chainOptions.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.chainName}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.chainNetwork}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>Token Address *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenAddress"
                    value={form.tokenAddress}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenAddress}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenAddress}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>Token Symbol *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenSymbol"
                    value={symbol}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenSymbol}
                    disabled={!update?true:false}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenSymbol}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mt-4">
                  <Form.Label>Description *</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    placeholder="max 1500 characters"
                    value={form.description}
                    onChange={handleInputChange}
                    isInvalid={!!errors.description}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Col>

                  <Col lg={12} className="mt-4">
                  <Form.Label>ADD a Brand Logo/Upload a Logo *</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type="file"
                      className="custom_dragdrop_form"
                      onChange={handleFileChange}
                      isInvalid={!!errors.logo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.logo}
                    </Form.Control.Feedback>
                    <div className="custom_dragdrop my-3">
                      <span>
                        Click to upload files, or drag & drop files here
                      </span>
                    </div>
                    {imagePreview && (
                      <div className="image-preview mt-3">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ maxHeight: "200px", maxWidth: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>ADD KYC</Form.Label>
                  <Form.Control
                    type="text"
                    name="kyc"
                    value={form.kyc}
                    onChange={handleInputChange}
                    isInvalid={!!errors.kyc}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.kyc}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>ADD Audit</Form.Label>
                  <Form.Control
                    type="text"
                    name="audit"
                    value={form.audit}
                    onChange={handleInputChange}
                    isInvalid={!!errors.audit}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.audit}
                  </Form.Control.Feedback>
                </Col>
                <Col lg={12} className="mt-4">
                  <Form.Label>Website *</Form.Label>
                      <Form.Control
                        type="text"
                        name="website"
                        className="mb-2"
                        placeholder="Website"
                        value={form.website}
                        onChange={handleInputChange}
                        isInvalid={!!errors.website}
                      />
                  <Form.Control.Feedback type="invalid">
                    {errors.website}
                  </Form.Control.Feedback>
                </Col>
                
              <Row className="mt-4">
                <h5>Tokenomics</h5></Row>

                <Col lg={6} className="mt-4">
                  <Form.Label>Token Liquidity *</Form.Label>
                  <Form.Control
                    type="number"
                    name="liquidityValue"
                    placeholder="Value"
                    value={form.liquidityValue}
                    onChange={handleInputChange}
                    isInvalid={!!errors.liquidityValue}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.liquidityValue}
                  </Form.Control.Feedback>
                </Col>
                
                <Col lg={6} className="mt-4">
                  <Form.Label>USDT Liquidity Amount *</Form.Label>
                  <Form.Control
                    type="number"
                    name="usdtAmount"
                    placeholder="Value"
                    value={form.usdtAmount}
                    onChange={handleInputChange}
                    isInvalid={!!errors.usdtAmount}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.usdtAmount}
                  </Form.Control.Feedback>
                </Col>
                <Col lg={6} className="mt-4">
                </Col>
                <Row>
                <Col lg={6} className="mb-4">
                  <Form.Label>Sale Start Date & Time *</Form.Label>
                  <div className="datetime position-relative">
                    <DatePicker
                    selected={form.startDateAndTime}
                    onChange={(date) => handleInputChange({ target: { name: "startDateAndTime", value: date } })}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="dd/MM/yyyy h:mm aa"
                    minDate={now}
                    minTime={form.startDateAndTime && form.startDateAndTime.toDateString() === now.toDateString() ? minSelectableTime : new Date(0, 0, 0, 0, 0)} 
                    maxTime={new Date(0, 0, 0, 23, 45)} 
                    customInput={
                      <Form.Control
                        isInvalid={!!errors.startDateAndTime}
                        placeholder="Select date & Time"
                      />
                    }
                  />
                  <span className="position-absolute end-0 top-0 bottom-0 d-flex h-100 align-items-center pe-2"><MdOutlineDateRange/></span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.startDateAndTime}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col lg={12}>
                  <Form.Label>Whitepaper *</Form.Label>
                  <Form.Control
                    type="text"
                    name="whitepaper"
                    placeholder="Add a whitepaper link here."
                    value={form.whitepaper}
                    onChange={handleInputChange}
                  />
                </Col>
                </Row>
                            <Form.Label className="mt-4">
                              Project Social Accounts (Up to 10 accounts)
                            </Form.Label>
                            {form.socialAccounts.map((account, index) => (
                              <React.Fragment key={index}>
                                <Col lg={6} className="mb-4">
                                  <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Social Account name"
                                    value={account.name}
                                    onChange={(e) => handleSocialAccountChange(index, e)}
                                  />
                                </Col>
                                <Col lg={6} className="mb-4">
                                  <Form.Control
                                    type="text"
                                    name="link"
                                    placeholder="Add a link here."
                                    value={account.link}
                                    onChange={(e) => handleSocialAccountChange(index, e)}
                                  />
                                </Col>
                              </React.Fragment>
                            ))}
                            <div className="text-end">
                              <Button variant="add" onClick={addSocialAccount}>
                                + Add more
                              </Button>
                            </div>
              </Row>
              <div className="mt-5">
                <h6>
                  IMPORTANT: Special Liquidity Management SpecialLM - must agree *
                </h6>
                <p>
                  (Here is the description for the project owners, what they
                  have to agree upon prior to listing their project. This will
                  be a contract between INFI CDEX and the starting project that
                  needs to be <b>AGREE</b> and <b>CONFIRM</b> by the project
                  owner)
                </p>
              </div>

              <div className="d-flex align-items-baseline">
                <Form.Check
                  className="me-2"
                  checked={form.agree}
                  onChange={handleCheckboxChange}
                  isInvalid={!!errors.agree}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.agree}
                </Form.Control.Feedback>
                <span>
                  Project owners must lock liquidity for a minimum of six
                  months, during which the liquidity remains inaccessible.
                  Safeguards are in place for companies to investigate and halt
                  trading if a scam or suspicious transaction is spotted. In
                  case of a confirmed scam, investors take precedence, impacting
                  the locked liquidity. Post the lock period, project owners
                  need approval from INFI ADMIN to access the liquidity, and
                  must justify their request
                </span>
              </div>

              <hr />

              <div className="mt-4 text-center">
                <Button variant="dark" className="px-4 py-2"onClick={e=>{handleSubmit(e)}} >
                  Submit
                </Button>
                <p className="mt-2">
                  Never submit password or credit card details through workform
                </p>
              </div>
            </div>
          </Form>
        </Container>
      </section>
      <Footer />
    </>
  );
}